import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// bootstrap imported in App.js — do NOT import here again (double CSS = slower load)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
